import { Head } from '@inertiajs/react';
import type { LandingsMate } from '@/types';
import { RotatingMate } from './components/rotating-mate';

// `app/(public)/26-ar/mate/page.tsx`.
export default function Mate({ title, description }: LandingsMate) {
  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
      </Head>
      <main className="selection-on-light relative min-h-dvh w-full overflow-hidden bg-primary text-background md:h-dvh">
        <RotatingMate />
      </main>
    </>
  );
}
